import React from 'react';
import { ClearList } from '../components';
import { useClearAppListQuery } from '../queries';
import { Spinner } from '@agilepoint/wat-react-ux';

interface IClearAppListContianerProps {
    onClearInternalState: () => void;
}

export const ClearAppListContainer = React.memo((props: IClearAppListContianerProps) => {
    const { mutateAsync, isLoading } = useClearAppListQuery();

    if (isLoading) {
        return <Spinner spinnerType='indeterminate' size='small' />;
    }

    return (
        <ClearList onClearList={mutateAsync} onClearInternalState={props.onClearInternalState} />
    );
});
